import { formatTimeForDisplay } from "@repo/app-types/entities/schedulingConfiguration";
import { SimpleSelect, type SimpleSelectOption } from "./simpleSelect.js";

interface TimeSelectProps {
  value: string; // Format: "HH:MM"
  onChange: (value: string) => void;
  minTime?: string; // Format: "HH:MM"
  label?: string;
  isDisabled?: boolean;
  use24HourFormat?: boolean;
  isLabelHidden?: boolean;
}

const generateTimeOptions = (
  minTime?: string,
  use24HourFormat?: boolean,
): SimpleSelectOption<string>[] => {
  const options: SimpleSelectOption<string>[] = [];
  const minHour = minTime ? parseInt(minTime.split(":")[0] ?? "0", 10) : 0;
  const minMinute = minTime ? parseInt(minTime.split(":")[1] ?? "0", 10) : 0;

  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      // Skip times before minTime
      if (hour < minHour || (hour === minHour && minute < minMinute)) {
        continue;
      }

      const timeString = `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
      options.push({
        value: timeString,
        label: formatTimeForDisplay(timeString, Boolean(use24HourFormat), true),
      });
    }
  }

  return options;
};

export const TimeSelect = ({
  value,
  onChange,
  minTime,
  label,
  isDisabled = false,
  use24HourFormat,
  isLabelHidden = false,
}: TimeSelectProps) => {
  const options = generateTimeOptions(minTime, use24HourFormat);

  return (
    <div className="w-[110px]">
      <SimpleSelect
        label={label}
        value={value}
        onChange={onChange}
        options={options}
        isDisabled={isDisabled}
        placeholder="Select time"
        isLabelHidden={isLabelHidden}
      />
    </div>
  );
};
